import React, { useRef, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import Carousel from "react-bootstrap/Carousel";

const VirtualTourWrapper = styled.div`
  height: calc(100% - 70px);
  margin: 20px 20px;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  box-shadow: 3px 3px 6px 0px rgba(169, 169, 169, 0.25);

  .carousel-item {
    height: calc(100vh - 340px);
  }

  .slide {
    height: calc(100vh - 300px);
  }

  .carousel-caption {
    color: black;
    bottom: -10px;
    padding-bottom: 0;
  }

  .carousel-indicators {
    bottom: 5px !important;

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakSmall}) {
      bottom: -5px !important;
    }
    li {
      background: black;
      border: none;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }

  .carousel-control-next,
.carousel-control-prev /*, .carousel-indicators */ {
    filter: invert(100%);
    height: 50px;
    top: unset;
    bottom: 0;
  }

  .carousel-control-prev,
  .carousel-control-next {
    align-items: end;
    padding-bottom: 40px;
    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakSmall}) {
      padding-bottom: 27px;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    height: calc(100% - 150px);
    padding-botttom: 80px;
    margin-bottom: 0;

    .carousel-item {
      height: 340px;
    }

    .slide {
      height: auto;
    }

    .carousel-caption {
      bottom: 19px;
    }

    .carousel-control-next,
    .carousel-control-prev /*, .carousel-indicators */ {
      height: 50px;
      top: unset;
      bottom: 0;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakMedium}) {
     height: calc(100% - 140px);

    .carousel-item {
      height: 100%;
    }

    .slide {
      height: 100%;
    }

    .carousel-inner {
      height: 100%;
    }
  }


  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    height: calc(100% - 130px);
    margin: 0 15% !important;
  }
`;

const VirtualTourIframe = styled.iframe`
  width: 100%;
  height: fit-content;
  background: black;
  border-radius: 8px 8px 0px 0px;
  height: calc(100vh - 375px);

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    height: 386px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    height: calc(100% - 64px);
  }
`;

function VirtualTour({ floorplan, lang }) {
  const virtualTours = floorplan.virtual_tours;
  const iframeRef = useRef(null);
  return (
    <VirtualTourWrapper>
      <Carousel indicators={true} interval={null} wrap={false}>
        {virtualTours.map((tour, index) => {
          const inputString = tour.name;
          const regexEn = /<en>(.*?)<\/en>/;
          const regexEs = /<es>(.*?)<\/es>/;
          let wordEn;
          let wordEs;
          inputString.match(regexEn) ? wordEn = inputString.match(regexEn)[1] : wordEn = tour.name;
          inputString.match(regexEs) ? wordEs = inputString.match(regexEs)[1] : wordEs = tour.name;         
          return (
            <Carousel.Item key={index}>
              <VirtualTourIframe
                src={tour.url}
                ref={iframeRef}
              ></VirtualTourIframe>
              <Carousel.Caption>
                <h5>{lang === "English" ? wordEn : wordEs}</h5>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </VirtualTourWrapper>
  );
}

const mapStateToProps = (state) => ({
  floorplan: state.floorplan.selectedFloorplan,
  lang: state.settings.language,
});

export default connect(mapStateToProps, null)(VirtualTour);
